import { IWebsiteBuilderRoot } from "pages/secure/facility/websiteBuilder/editor/nodes/root/websiteBuilderRoot";
import { TWebsiteBuilderDevice } from "pages/secure/facility/websiteBuilder/editor/website/shared/device";
import { IWebsiteBuilderEditorHistoryActionBase, IWebsiteBuilderHistorySnapshot, WebsiteBuilderEditorActionType } from "../../websiteBuilderEditorAction";
import { IWebsiteBuilderHeader } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderHeader";
import { IWebsiteBuilderFooter } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderFooter";
import { TWebsiteBuilderMainSection } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderSection";

export type TMoveSectionDirection = "up" | "down";

export interface IMoveSectionActionPayload {
  id: string;
  prevIndex: number;
  nextIndex: number;
}

export interface IMoveSectionAction extends IWebsiteBuilderEditorHistoryActionBase {
  type: typeof WebsiteBuilderEditorActionType.MOVE_SECTION;
  payload: IMoveSectionActionPayload;
}

export function getMoveSectionInverseAction(action: IMoveSectionAction): IMoveSectionAction {
  const { id, prevIndex, nextIndex } = action.payload;

  return {
    type: WebsiteBuilderEditorActionType.MOVE_SECTION,
    pageId: action.pageId,
    device: action.device,
    scrollNodeId: action.scrollNodeId,
    payload: {
      id,
      prevIndex: nextIndex,
      nextIndex: prevIndex,
    },
  };
}

export function applyMoveSectionChange(
  header: IWebsiteBuilderHeader,
  root: IWebsiteBuilderRoot,
  footer: IWebsiteBuilderFooter,
  action: IMoveSectionAction,
): IWebsiteBuilderHistorySnapshot {
  const { id, prevIndex, nextIndex } = action.payload;

  const defaultHistorySnapshot: IWebsiteBuilderHistorySnapshot = { header, root, footer };

  if (header.id === id || footer.id === id || nextIndex < 0 || nextIndex >= root.children.length) {
    return defaultHistorySnapshot;
  }

  const updatedRootChildren = [...root.children];
  const [movedSection] = updatedRootChildren.splice(prevIndex, 1);
  updatedRootChildren.splice(nextIndex, 0, movedSection);

  const updatedRoot: IWebsiteBuilderRoot = {
    ...root,
    children: updatedRootChildren,
  };

  return { header, root: updatedRoot, footer };
}

export function getMoveSectionTargetIndex(
  index: number,
  direction: TMoveSectionDirection,
  children: TWebsiteBuilderMainSection[],
  device: TWebsiteBuilderDevice,
): number {
  if (index < 0 || index >= children.length) {
    return -1;
  }

  const step = direction === "up" ? -1 : 1;

  for (let nextIndex = index + step; nextIndex >= 0 && nextIndex < children.length; nextIndex += step) {
    if (children[nextIndex].section.visibility[device]) {
      return nextIndex;
    }
  }

  return -1;
}